<h1 mat-dialog-title>Edit Purchase Order</h1>

<div mat-dialog-content>
  <mat-form-field class="w-full mt-12">
    <mat-label>Purchase Order</mat-label>
    <input
      matInput
      name="Purchase order"
      [formControl]="poFc"
      placeholder="Purchase Order"
    />
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="save()">Save</button>
</div>
